import { Injectable } from '@angular/core';
import { PagePath } from '../enums/page-path.enum';
import type { ConfigResourceService } from './config-resource.service';

@Injectable({
  providedIn: 'root'
})
export class RouteOptionsService {
  getDisabledRoutes(configService: ConfigResourceService): PagePath[] {
    const routes: PagePath[] = [];

    if (configService.getProcessedResourceValue<boolean>('DC5_Header_ShowPrescription', true) === false) {
      routes.push(PagePath.ACCOUNT_PRESCRIPTIONS);
    }
    if (configService.getProcessedResourceValue<boolean>('MDCHeaderShowPharmacyTab', true) === false) {
      routes.push(PagePath.PHARMACIES, PagePath.PHARMACY_DETAILS);
    }
    if (configService.getProcessedResourceValue<boolean>('DC5_Header_Show_Coverage_Page', true) === false) {
      routes.push(PagePath.ACCOUNT_COVERAGE);
    }
    if (configService.getProcessedResourceValue<boolean>('IsMDCAnnualCostPageOn', true) === false) {
      routes.push(PagePath.ANNUAL_COST_REPORT);
    }

    return routes;
  }
}
